import React from 'react';
import Link from 'ui/base/Link';

class PrivacyPolicyLink extends React.Component {
    /**
     * Component state
     */
    state = {};

    /**
     * Constructor
     * @param props
     */
    constructor(props) {
        super(props);
    }

    /**
     * Render component
     */
    render() {
        return (
            <Link styled to="https://www.mentia.me/deva-privacy-policy/" target="_blank">
                Privacy Policy
            </Link>
        );
    }

    /**
     * Properties initilization
     */
    static propTypes = {};
    static defaultProps = {};
}

export default PrivacyPolicyLink;
